import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL = `${BaseUrl}promo`;

export const getPromos = () => {
    const token = localStorage.getItem('token');

    return axios.get(API_URL, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    })
}

export const getPromoById = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const validatePromoPost = (product) => {
    const token = localStorage.getItem('token');

    return axios.post(`${API_URL}/validate-code-promo`, product, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}